import { useMemo } from 'react';
import { v4 } from 'uuid';

const useUniqueHash = () => useMemo(() => v4().substring(0, 255), []);

export default useUniqueHash;
